import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { SESSION_LANGUAGE_URL } from '../../../NonReact/constants/ApiConstants'
import { SessionLanguage } from '../Constants/LanguageConstants'
import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { RESTMethods } from '../../../NonReact/constants/REST'

export const getSessionLanguage = (): Promise<Nullable<string>> =>
    requestGetJSON<SessionLanguage>(SESSION_LANGUAGE_URL).then(
        (sessionLanguage: Nullable<SessionLanguage>): Nullable<string> => sessionLanguage?.language
    )

export const setSessionLanguage = (language: string): Promise<Nullable<void>> =>
    requestJSON(SESSION_LANGUAGE_URL, { method: RESTMethods.PUT, body: { language } })
